import React, { useState, useEffect } from 'react'

//antd
import { Col, Row, Select } from 'antd'

//apis
import { getBranches } from 'apis/branch'
import { getCountries } from 'apis/country'
import { getRegions } from 'apis/region'

export default function FilterRegion({ setParamsFilter, paramsFilter, width_size }) {
  const [countries, setCountries] = useState([])
  const [countryId, setCountryId] = useState()

  const [regions, setRegions] = useState([])
  const [regionId, setRegionId] = useState()

  const [branches, setBranches] = useState([])
  const [branchId, setBranchId] = useState()

  const [valueSearch, setValueSearch] = useState()

  const toggleMouseLeave = () => {
    setBranchId([])
  }

  const _getCountries = async () => {
    try {
      const res = await getCountries()
      if (res.status === 200) setCountries(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }
  const _getRegions = async (query) => {
    try {
      const res = await getRegions(query)
      if (res.status === 200) setRegions(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }
  const _getBranches = async (query) => {
    try {
      const res = await getBranches(query)
      if (res.status === 200) setBranches(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    _getCountries()
    _getRegions()
    _getBranches()
  }, [])

  useEffect(() => {
    if (countries.length && regions.length && branches.length) {
      const country = countries.find((c) => c.country_id === paramsFilter.country_id)
      const region = regions.find((c) => c.region_id === paramsFilter.region_id)
      const branch = branches.find((c) => c.branch_id === paramsFilter.branch_id)
      setValueSearch(
        `${country ? country.name : ''}${region ? '/' + region.name : ''}${
          branch ? '/' + branch.name : ''
        }`
      )
    }
  }, [countries, regions, branches, paramsFilter])

  return (
    <div>
      <Select
        allowClear
        value={valueSearch || undefined}
        onChange={(e) => {
          if (!e) {
            setValueSearch()
            delete paramsFilter.country_id
            delete paramsFilter.region_id
            delete paramsFilter.branch_id
            setParamsFilter({ ...paramsFilter })
          }
        }}
        style={{ width: width_size }}
        placeholder="Chọn quốc gia/ khu vực/ chi nhánh"
        size="large"
        dropdownRender={() => (
          <Row justify="space-between" onMouseLeave={toggleMouseLeave}>
            <Col span={6}>
              {countries.map((country, index) => (
                <Row
                  key={index}
                  style={{
                    color: '#000',
                    padding: '2px 10px',
                    margin: '1px 3px',
                    cursor: 'pointer',
                    backgroundColor:
                      paramsFilter.country_id === country.country_id ||
                      countryId === country.country_id
                        ? '#5F73E290'
                        : '',
                    borderRadius: 10,
                  }}
                  value={country.country_id}
                  onMouseEnter={() => {
                    setCountryId(country.country_id)
                    setBranchId([])
                  }}
                  onClick={() => {
                    setParamsFilter({
                      ...paramsFilter,
                      country_id: country.country_id,
                      region_id: '',
                      branch_id: '',
                    })
                  }}
                >
                  {country.name}
                </Row>
              ))}
            </Col>
            <Col span={7}>
              {regions.map((region, index) =>
                countryId === region.country_id ? (
                  <Row
                    key={index}
                    style={{
                      color: '#000',
                      padding: '2px 10px',
                      margin: '1px 3px',
                      cursor: 'pointer',
                      backgroundColor:
                        paramsFilter.region_id === region.region_id || regionId === region.region_id
                          ? '#5F73E290'
                          : '',
                      borderRadius: 10,
                    }}
                    value={region.region_id}
                    onMouseEnter={() => {
                      setRegionId(region.region_id)
                      setBranchId([])
                    }}
                    onClick={() => {
                      setParamsFilter({
                        ...paramsFilter,
                        country_id: countryId,
                        region_id: region.region_id,
                        branch_id: '',
                      })
                    }}
                  >
                    {region.name}
                  </Row>
                ) : (
                  ''
                )
              )}
            </Col>
            <Col span={11}>
              {branches.map((branch, index) =>
                regionId === branch.region_id ? (
                  <Row
                    key={index}
                    style={{
                      color: '#000',
                      padding: '2px 10px',
                      margin: '1px 3px',
                      cursor: 'pointer',
                      backgroundColor:
                        paramsFilter.branch_id === branch.branch_id || branchId === branch.branch_id
                          ? '#5F73E290'
                          : '',
                      borderRadius: 10,
                    }}
                    value={branch.branch_id}
                    onMouseEnter={() => setBranchId(branch.branch_id)}
                    onClick={() => {
                      setParamsFilter({
                        ...paramsFilter,
                        country_id: countryId,
                        region_id: regionId,
                        branch_id: branch.branch_id,
                      })
                    }}
                  >
                    {branch.name}
                  </Row>
                ) : (
                  ''
                )
              )}
            </Col>
          </Row>
        )}
      ></Select>
    </div>
  )
}
